import { Button } from "primereact/button"
import { CommodityCreator } from "./CommodityCreator"
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { SubCommodityCreator } from "./SubCommodityCreator/SubCommodityCreator";


export const CommodityCreatorWrapper = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const isSubPage = location.pathname.includes("sub");
    return (
        <>
            {!isSubPage && (
                <div className="w-full">
                    <Button
                        className="flex align-items-end mt-2 col-offset-10"
                        label='Subcommodity?'
                        onClick={() => navigate('sub')}
                    />
                    <CommodityCreator />
                </div>
            )}
            {
                isSubPage &&
                <>
                    <Button
                        className="mt-2 col-offset-10"
                        label='Back'
                        icon="pi pi-arrow-left"
                        onClick={() => navigate('/commodity-creator')}
                    />
                </>
            }
            <Outlet />
        </>
    )
}